import {
    Col,
    Form,
    Input,
    Row,
    Table,
} from 'antd';
import type { TablePaginationConfig } from 'antd/es/table';
import Button from 'mixins/ui/button/button';
import React, { FC, useMemo } from 'react';
import { GenerationsData } from '../admin-token-generations';
import { getTokenGenerationsColumns } from './token-generations-columns';

interface TokenGenerationsTableProps {
    data: GenerationsData[];
    isLoading: boolean;
    pagination: TablePaginationConfig;
    translations: Record<string, string>;
    taxpayerCode: string;
    onPageChange: (page: number) => void;
     onPageSizeChange: (
        current: number,
        size: number
    ) => void;

    onTokenAction: (
        id: string,
        action: 'block' | 'unblock' | 'delete',
        taxpayerCode?: string
    ) => void;

    onTaxpayerCodeChange: (
        value: string
    ) => void;

    onTaxpayerCodeSearch: () => void;

    onTaxpayerCodeReset: () => void;
}

export const TokenGenerationsTable:
    FC<TokenGenerationsTableProps> = ({
        data,
        isLoading,
        pagination,
        translations,
        taxpayerCode,
        onPageChange,
        onPageSizeChange,
        onTokenAction,
        onTaxpayerCodeChange,
        onTaxpayerCodeSearch,
        onTaxpayerCodeReset,
    }) => {
        const columns = useMemo(
            () =>
                getTokenGenerationsColumns({
                    translations,
                    onTokenAction,
                }),
            [translations, onTokenAction]
        );

        const searchDisabled =
            taxpayerCode.length !== 12;

        return (
            <>
                <Form
                    layout="vertical"
                    className="admin-token-generations__filters"
                >
                    <Row
                        gutter={[16, 8]}
                        align="bottom"
                    >
                        <Col
                            xs={24}
                            md={8}
                        >
                            <Form.Item label="ИИН/БИН">
                                <Input
                                    value={taxpayerCode}
                                    size="large"
                                    allowClear
                                    maxLength={12}
                                    placeholder="Введите ИИН/БИН"
                                    onChange={(event) =>
                                        onTaxpayerCodeChange(
                                            event.target.value
                                        )
                                    }
                                    onPressEnter={() => {
                                        if (!searchDisabled) {
                                            onTaxpayerCodeSearch();
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col
                            xs={24}
                            md={8}
                        >
                            <Form.Item>
                                <div className="admin-token-generations__filter-actions">
                                    <Button
                                        disabled={
                                            searchDisabled
                                        }
                                        onClick={
                                            onTaxpayerCodeSearch
                                        }
                                    >
                                        Найти
                                    </Button>

                                    <Button
                                        onClick={
                                            onTaxpayerCodeReset
                                        }
                                    >
                                        Сбросить
                                    </Button>
                                </div>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Table
                    className="my-3 admin-token-generations__table"
                    dataSource={data}
                    columns={columns}
                    loading={isLoading}
                    rowKey="id"
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        onChange: onPageChange,
                        onShowSizeChange:
                            onPageSizeChange,
                    }}
                    scroll={{
                        x: true,
                    }}
                />
            </>
        );
    };